import { isObject } from './objectUtil';
import { createParam } from './parameterUtil';

/**
 * formの遷移機能
 * @param path
 * @param data
 * @param params
 */
export function postForm(
  path: string,
  data: Record<string, string | number | boolean>,
  params: Record<string, string | number | boolean>
) {
  const parameter = createParam(params);
  const form = document.createElement('form');
  form.method = 'post';
  form.action = path + parameter;
  if (isObject(data)) {
    Object.keys(data).forEach((key) => {
      const hiddenField = document.createElement('input');
      hiddenField.type = 'hidden';
      hiddenField.name = key;
      hiddenField.value = `${data[key] ?? ''}`;

      form.appendChild(hiddenField);
    });
  }
  if (data) document.body.appendChild(form);
  form.submit();
}

type Data<T> = { [K in keyof T]: string | null };

/**
 * formDataにセットします
 * @param data
 */
export function setFormData<T extends object>(data: T & Data<T>) {
  const formData = new URLSearchParams();
  if (isObject(data)) {
    Object.keys(data).forEach((k) => {
      formData.append(k, data[k as keyof typeof data] ?? '');
    });
  }
  return formData;
}
